module.exports = __webpack_public_path__ + "static/media/icon-particulates.ab40f3e6.svg";